type RegexValidators = {
  email: RegExp;
  fax: RegExp;
  phoneNumber: RegExp;
  zipCode: RegExp;
};

export const regexValidators: RegexValidators = {
  // email: /^\b\d{5}(-\d{4})?\b$/,
  email: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
  fax: /^(\+?\d{1,}(\s?|\-?)\d*(\s?|\-?)\(?\d{2,}\)?(\s?|\-?)\d{3,}\s?\d{3,})$/,
  phoneNumber: /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/,
  zipCode: /^\b\d{5}(-\d{4})?\b$/,
};
